type IconName = 'cloudDownload' | 'clock' | 'warn' | 'arrow' | 'apple' | 'android' | 'retry' | 'trash' | 'render'

interface IconProps {
  name: IconName
  size?: number
}

const Icon = ({name, size = 14}: IconProps) => {
  const stroke = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  const filled = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
  }
  switch (name) {
    case 'cloudDownload':
      return (
        <svg {...stroke}>
          <path d="M7 18a5 5 0 01-1-9.9 6 6 0 0111.7 1.4A4.5 4.5 0 0117 18" />
          <path d="M12 11v8" />
          <path d="M8.5 15.5L12 19l3.5-3.5" />
        </svg>
      )
    case 'clock':
      return (
        <svg {...stroke}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )
    case 'warn':
      return (
        <svg {...stroke}>
          <path d="M12 4l9.5 16h-19L12 4z" />
          <path d="M12 11v4" />
          <circle cx="12" cy="17.5" r="0.6" fill="currentColor" />
        </svg>
      )
    case 'arrow':
      return (
        <svg {...stroke}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      )
    case 'retry':
      return (
        <svg {...stroke}>
          <path d="M20 11a8 8 0 10-.6 4" />
          <path d="M20 4v6h-6" />
        </svg>
      )
    case 'trash':
      return (
        <svg {...stroke}>
          <path d="M4 7h16" />
          <path d="M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2" />
          <path d="M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12" />
          <path d="M10 11v6M14 11v6" />
        </svg>
      )
    case 'render':
      return (
        <svg {...stroke}>
          <circle cx="12" cy="12" r="9" />
          <path d="M10 8.5l5 3.5-5 3.5z" fill="currentColor" />
        </svg>
      )
    case 'apple':
      return (
        <svg {...filled}>
          <path d="M16.365 1.43c0 1.14-.41 2.18-1.18 3.04-.79.88-2.07 1.55-3.05 1.47-.13-1.09.39-2.21 1.13-3.04.84-.92 2.26-1.6 3.1-1.47zm3.99 16.21c-.55 1.27-.81 1.84-1.52 2.96-.99 1.56-2.38 3.5-4.11 3.51-1.54.02-1.93-1-4.01-.99-2.08.01-2.52 1-4.06.99-1.73-.01-3.05-1.76-4.04-3.32-2.77-4.35-3.06-9.46-1.35-12.18 1.21-1.93 3.13-3.06 4.93-3.06 1.84 0 2.99 1 4.5 1 1.47 0 2.36-1 4.49-1 1.61 0 3.32.88 4.54 2.4-3.99 2.19-3.34 7.89.63 9.69z" />
        </svg>
      )
    case 'android':
      return (
        <svg {...filled}>
          <path d="M17.523 15.34a1 1 0 110-2 1 1 0 010 2zm-11.046 0a1 1 0 110-2 1 1 0 010 2zm11.405-6.072l1.997-3.46a.416.416 0 00-.72-.416l-2.022 3.503a12.564 12.564 0 00-10.274 0L4.84 5.392a.416.416 0 00-.72.416l1.997 3.46C2.69 11.123.5 14.467.5 18.25h23c0-3.783-2.19-7.127-5.618-8.982z" />
        </svg>
      )
    default:
      return null
  }
}

export default Icon
